<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-configuration-message-blacklist">
    <div v-if="isRoleAllow([4201, 900013])" class="configuration-topics-header" v-bind:class="{'isDisabled': loading}">
      <el-input ref="messageInput" placeholder="Please type a message or a regular expression, and press enter." :disabled="loading"
        class="message-input" v-model="messageInput" @keyup.native="handleKeypress"></el-input>
      <div class="tips">RegEx examples: <span class="highlights">/John/i</span>, <span class="highlights">/\$trigger/i</span> (For more examples, please refer to <a href="https://www.w3schools.com/jsref/jsref_obj_regexp.asp" target="_help">Help</a>)</div>
    </div>

    <div class="topic-group-section">
      <div class="div-group-viewer-header div-group-name">
        Blacklisted Messages
      </div>
      <div class="div-group-viewer-content">
        <div class="div-group-topics">
          <div class="div-topic-content" ref="topicContent"  v-loading="loading">
            <div v-if="data && data.length > 0">
              <div class="div-item" :title="item.message" v-for="(item, index) in data" :key="index">
                <div class="div-ellipsis-item">{{item.message}}</div> 
                <i v-if="isRoleAllow([4201, 900013])" class="el-icon-error" @click="handleRemove(item)"></i>
              </div>
            </div>
            <div v-else class="no-data">
              <div class="no-data-icon"></div>
              <div class="no-data-title">Sorry!</div>
              <div class="no-data-content">
                No data available yet for this brand or time period. Please use the global filter to select a brand and time period with data available.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  
</template>

<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex';
  export default Vue.extend({
    name: 'wy-analytics-configuration-message-blacklist',
    title: 'Configuration',
    props: ['controller'],
    data() {
      return {
        loading: false,
        messageInput: '',
        data: null
      }
    },

    computed: {
      ...mapGetters(['dataModel', 'isRoleAllow']),
    },
    
    methods: {
      ...mapActions(['fetchContactReasonsBlackListsMessages', 'addContactReasonBlackListMessage', 'removeContactReasonBlackListMessage']),

      async loadData() {
        if(this.isRoleAllow([4201, 900013])) {
          let res = await this.fetchContactReasonsBlackListsMessages();
          if(res.status == 200) {
            this.data = res.data;
          }
        }
      },

      async handleKeypress(e) {
        if(this.isRoleAllow([4201, 900013])) {
          this.messageInput = this.messageInput.trim();
          
          if(e.keyCode == 13 && this.messageInput && this.messageInput.length > 0) {
            this.loading = true;

            let isValidInput = true;
            if(this.messageInput == "//") {
              isValidInput = false;
            }
            else if(this.messageInput.indexOf('/') === 0 && this.messageInput.indexOf('/', 2) > -1) {
              try {
                eval(this.messageInput)
              }
              catch(e) {
                isValidInput = false;
              }
            }

            if(isValidInput) {
              let res = await this.addContactReasonBlackListMessage(this.messageInput);
              if(res.status == 200) {
                this.$root.showNotificationLocale("success", null, "notifications.blacklistMessageAddSuccess");
                this.messageInput = '';
                setTimeout(() => { this.$refs.messageInput.focus(); }, 300)
                await this.loadData();
              }
              else {
                this.$root.showNotificationLocale("error", "error.serverErrorTitle", "error.serverErrorMsg");
              }
            }
            else {
              this.$root.showNotificationLocale("error", null, "notifications.blacklistMessageInvalidRegEx");
            }
            this.loading = false;
          }
        }
      },
      
      async handleRemove(item) {
        if(this.isRoleAllow([4201, 900013])) {
          this.loading = true;
          let res = await this.removeContactReasonBlackListMessage(item.message);
          if(res.status == 200) {
            this.$root.showNotificationLocale("success", null, "notifications.blacklistMessageRemoveSuccess");
            await this.loadData();
          }
          else {
            this.$root.showNotificationLocale("error", "error.serverErrorTitle", "error.serverErrorMsg");
          }        
          this.loading = false;
        }
      },
    },

    async created() {
      await this.loadData();
    }
  });
</script>

<style lang="scss">
.wy-analytics-configuration-message-blacklist {
  width: 100%;
  height: 100%;

  .no-data {
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .no-data-icon {
      display: block;
      border: none;
      height: 155px;
      width: 155px;
      background-position-x: 50%;
      background-repeat: no-repeat;
      background-image: url(../../../assets/icons/icon_no_data_new.svg);
      margin-bottom: 10px;
    }
    .no-data-title {
      font-size: 21px !important;
      color: var(--site-font-tertiary-color) !important;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .no-data-content {
      font-size: 14px;
      color: #4B5158 !important;
      line-height: 22px;
      text-align: center;
      width: 415px;
    }
  }
  
  .el-loading-mask {
    bottom: 12px;
    .el-loading-spinner {
      top: 35%;
      background: var(--site-loading-icon);
      background-repeat: no-repeat;
      background-size: 25px;
      background-position: center;    
      .circular {
        display: inline-block;
        width: 90px;
        height: 90px; 
      }
    }
    .el-loading-spinner .path {
      -webkit-animation: loading-dash 2s ease-in-out infinite;
      animation: loading-dash 2s ease-in-out infinite;
      stroke-dasharray: 90,150;
      stroke-dashoffset: 0;
      stroke-width: 2.5 !important;
      stroke: #0C2837 !important;
      stroke-linecap: round; 
    }
  }
  .configuration-topics-header {
    padding-top: 5px;
    padding-bottom: 15px;

    .tips {
      font-size: 13px;
      font-style: italic;
      color: #777;
      padding: 10px 0px 0px 10px;
      .highlights {
        color: #666;
        font-weight: bold;
      }
    }

    .message-input {
      display: inline-flex;
      width: 500px;
      padding-right: 7px;

      input.el-input__inner {
        height: 28px;
        padding-bottom: 0px;
        border: 1px solid #B3B3B3 !important;
        border-radius: 15px;
        padding-left: 15px;
      }
    }
  }
  .configuration-topics-header.isDisabled {
    pointer-events: none;
    opacity: 0.4;
  }

  .topic-group-section {
    //margin: 20px 0px 20px 0px;
    min-width: 700px;
    max-width: 900px;
    margin-right: 15px;
    width: 70%;
    height: calc(100% - 95px);
    overflow-y: hidden;
    padding: 14px 0px 0px 0px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #E8E8E8;
    border-radius: 15px;
    opacity: 1;

    .div-group-viewer-content {
      margin-top: 10px;
      border-top: 1px solid #E8E8E8;
      height: -webkit-fill-available;
      overflow-y: auto;
      overflow-x: hidden;
      margin-bottom: 12px;
      height: calc(100% - 25px);
    }

    .div-group-viewer-header.div-group-name {
      font-size: 16px;
      font-weight: 500;
      padding: 0px 10px 0px 30px;
    }
    .div-group-topics {
      margin-top: 0px;

      .div-topic-content {
        height: fit-content;
        // padding-top: 10px;

        .div-item {
          color: var(--site-font-primary-color);
          font-weight: normal;
          margin: 0px 0px 0px 0px;
          line-height: 19px;
          padding: 12px 10px 5px 30px;
          font-size: 12px;
          cursor: pointer;
          .div-ellipsis-item {
            width: 88%;
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .div-item:hover {
          background: #f5f7fa;
        }
        .div-item.selected {
          background: #E2ECF7;
        }

        .el-icon-error{
          float: right;
          // display: none;
          top: 2px;
          left: -10px;
          position: relative;
          color: #80A6CD;
          cursor: pointer;
          font-size: 15px;
        }
        .el-icon-error.is-disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }
        .div-item:hover .el-icon-error {
          display: block; 
        }
      }
    }
  }
}
</style>